var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.browserIsNotSupported)?_c('browse-happy-alert'):_vm._e(),_vm._v(" "),_c('the-header'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('the-footer'),_vm._v(" "),_c('client-only',[_c('portal-target',{attrs:{"name":"modal"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }